export default __webpack_public_path__ + "static/media/teams.649a5ca4.png";